export default "__VITE_ASSET__BtY32K28__"